<header class="dash-toolbar" style="background-color: #00cec9;">
  <div>
    <h3 style="color: white;display: inline-block;text-transform:capitalize;" id="name">
      <span style="color:#cecbcb;" id="name">Welcome </span>
    </h3>
  </div>
</header>
<div class="row">
  <div class="col-3">
    <div class="dash-nav dash-nav"
      style="background-color: white; background: url('assets/bottom-img.png'),url('assets/worldmap.png');background-repeat: no-repeat;background-position:bottom,top;background-size:auto,cover;background-color: white">
      <header style="background: rgba(0, 0, 0, 0.495)">

        <div style="text-align: center;">
          <img src="../../../../assets/logo.png" style="height: 55px;" />
        </div>
      </header>
      <nav class="dash-nav-list" style="margin-top: 40px">
        <a routerLink="/mr" class="dash-nav-item" routerLinkActive="active">
          <i class="fa fa-home"></i> Dashboard
        </a>
        <a routerLink="/mrappointment" class="dash-nav-item" routerLinkActive="active">
          <i class="fa fa-calendar"></i> Appointments
        </a>
        <a (click)="onlogout()" class="dash-nav-item" routerLinkActive="active">
          <i class="fa fa-calendar"></i> Logout
        </a>
      </nav>
      <div style="text-align: center;">
        <p
          style="color:white;font-size: 12px;word-wrap:break-word;text-align: center;position: absolute;bottom:1px;padding:5px">
          © Copyright <b>MAVIN GLOBUS</b><br />
          All Rights Reserved
        </p>
      </div>
    </div>
  </div>
  <div class="col-9" style="margin-top: 7%;">
    <div class="conatiner">
      <div class="row">
        <div class="col-3">
          <input [value]="City" (input)="findCity($event)" id="cityinput"
            style="text-transform: capitalize;max-width: 200px; border-right: 0; margin-left :25px; " autocomplete="off"
            type="text" class="form-control" placeholder="Enter City" aria-label="Recipient's username"
            aria-describedby="basic-addon2">
          <a *ngIf="iscity">
            <a *ngFor="let city of cities?.predictions" class="dropdown-item1" (click)="selectcity(city)"
              style=" font-size: 21px; cursor:pointer">{{city.description}}</a>
          </a>
        </div>
        <div class="col-4">
          <select class="form-select" (change)="gethosdoc($event)" style="margin-bottom: 30px;">
            <option *ngFor="let hospital of hos" [value]="hospital?._id">{{hospital.name}}</option>
          </select>
        </div>
        <div class="col-5">
        </div>
      </div>
    </div>
    <!-- <div *ngIf=""></div> -->
    <div class="container">
      <div *ngIf="cities?.length == 0">
        <p class="text-center" style="margin-top: 230px;">Please select city and hospital</p>
      </div>
      <table class="table" *ngIf="docdata?.length > 0">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Dr. Name</th>
            <th scope="col">O.P.D. Time</th>
            <th scope="col">Address</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of docdata">
            <th scope="row">1</th>
            <td>{{doc.name}}</td>
            <td>09:00-02:00</td>
            <td>{{curHospital}}</td>
            <button type="button" (click)="bookAppt(doc)" style="background-color: #00cec9;"
              class="btn btn-info">Book</button>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>